import React, { useId, useState } from "react";
import { navigate } from "gatsby";
import { normalizeRelativePath } from "../../utility/paths";
import classNames from "classnames";

const FooterNewsletter = ({ newsletter, labelManagerLabels }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const onSubmit = (e) => {
    if (isValidEmail(email)) {
      e.preventDefault();
      if (!email) return;
      const url = `${normalizeRelativePath(newsletter.newsletterPage.slug)}?email=${email}`;
      navigate(url);
    } else {
      setError(newsletter.errorMessage);
    }
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const onChange = (e) => {
    if (!isValidEmail(e.target.value)) {
      setError(newsletter.errorMessage);
    } else {
      setError(null);
    }

    setEmail(e.target.value);
  };

  const uniqueId = useId();
  const fieldId = `field${uniqueId}`;
  const [focused, setFocused] = useState(false);
  const handleFocus = () => setFocused(true);
  const handleBlur = (e) => {
    setFocused(false);
  };

  return (
    // <div className="footer__colSx">
    <div className="footer__newsletter-content">
      {newsletter.titleNewsletterBanner && (
        <span className="footer__span">{newsletter.titleNewsletterBanner}</span>
      )}
      <div className="footer__newsletter-input-container">
        <div
          className={classNames("newsletter__input-container form-field", {
            "form-field--focused": focused,
          })}
        >
          <label
            className="newsletter__input-label form-field__label"
            htmlFor={fieldId}
            id={`${fieldId}-label`}
          >
            {newsletter.placeholder}
          </label>
          <div className={classNames("newsletter__input-wrapper form-field__wrapper")}>
            <input
              id={fieldId}
              className="newsletter__input form-field__input"
              type="email"
              value={email}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onChange={onChange}
            />
          </div>
          {error && (
            <div className="form-field__error">
              <span>{error}</span>
            </div>
          )}
        </div>

        <button
          className="footer__newletter-button button primary red"
          type="submit"
          onClick={onSubmit}
        >
          <span className="">{labelManagerLabels?.subscribe}</span>
        </button>
      </div>
    </div>
    // </div>
  );
};

export default FooterNewsletter;
